import React from 'react';
import { DmsTable } from 'dmsbasereact';

export const InsightsTable = ({ tableRef, tableColumns, preFilters }) => {
    
    const url = `/dispensing/insights/table?filter=${encodeURIComponent(JSON.stringify(preFilters))}`;
    
    return (
        <DmsTable
            ref={tableRef}
            header={tableColumns}
            url={url}
            managed={true}
            needs_authentication={true}
            export_table={false}
        />
    );
};
